import { css } from 'styled-components'

const secondaryButtonTemplate = () => css`
  background: var(--sl-bg-critical-plain);
  color: var(--sl-fg-critical);

  &:hover {
    background: var(--sl-bg-critical-plain-hover);
    color: var(--sl-fg-critical-hover);
  }

  &.active {
    background: var(--sl-bg-critical-plain-pressed);
    color: var(--sl-fg-critical-pressed);
  }

  &:focus-visible {
    box-shadow: var(--sl-focus-ring-critical);
    background: var(--sl-bg-critical-plain-hover);
    color: var(--sl-fg-critical-hover);
  }

  &:disabled {
    background: transparent;
    color: var(--sl-fg-base-disabled);
  }
`

export default secondaryButtonTemplate
